module.exports = __webpack_public_path__ + "img/ic_dev_center.250e8f69.png";